document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.subCollection')) {
        document.querySelector('.subCollection').classList.remove('opacity_sub-col');
        new Swiper(".sub-swiper", {
            preloadImages: true,
            spaceBetween: 20,
            slidesPerView: 7,
            lazy: true,
            navigation: {
                prevEl: '.sub-button-prev',
                nextEl: '.sub-button-next',
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                576: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                991: {
                    slidesPerView: 5,
                    spaceBetween: 30
                },
                1100: {
                    slidesPerView: 6,
                    spaceBetween: 30
                },
                1500: {
                    slidesPerView: 7,
                    spaceBetween: 50
                }
            }

        });
    }
});
